import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '../shared/modules/shared.module';

import { routing } from './lead.routing';
import { AppComponent } from '../app.component';
import { ListComponent } from './list/list.component';
import { SummaryComponent } from './summary/summary.component';
import { AddComponent } from './add/add.component';
import { ConvertComponent } from './convert/convert.component';

import { AuthGuard } from '../auth.guard';
import { LeadService } from './services/lead.service';
import { RouterModule } from '@angular/router';
import { ListDesktopComponent } from './list/list-desktop/list-desktop.component';
import { ListMobileComponent } from './list/list-mobile/list-mobile.component';
import { SummaryDesktopComponent } from './summary/summary-desktop/summary-desktop.component';
import { SummaryMobileComponent } from './summary/summary-mobile/summary-mobile.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forRoot(routing, {}),
        SharedModule
    ],
    declarations: [ListComponent, ListDesktopComponent, ListMobileComponent,
        SummaryComponent, SummaryDesktopComponent, SummaryMobileComponent,
        AddComponent, ConvertComponent],
    exports: [],
    providers: [AppComponent, AuthGuard, LeadService]
})
export class LeadModule { }
